<template>
  <div>
    <load-profile />
    <section id="dashboard-analytics">
      <b-row class="match-height">
        <b-col lg="8" md="12">
          <coming-conversation-line-chart />
        </b-col>
        <b-col lg="4" md="12">
          <rating-pie-chart ref="ratingPieChart" :loading="loading" />
        </b-col>
        <b-col lg="4" md="12">
          <call-rating-pie-chart ref="callRatingPieChart" :loading="loading" />
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col md="12" lg="4">
          <StatisticCardHorizontal
            :loading="loading"
            :statistic="data.openConversation"
            :title="$t('dashboard.yourOpen')"
            :description="$t('dashboard.yourOpenDescription')"
            color="info"
          />
        </b-col>
        <b-col md="12" lg="4">
          <StatisticCardHorizontal
            :loading="loading"
            :statistic="data.resolvedConversation"
            :title="$t('dashboard.yourResolved')"
            :description="$t('dashboard.yourResolvedDescription')"
            color="success"
          />
        </b-col>
        <b-col md="12" lg="4">
          <StatisticCardHorizontal
            :loading="loading"
            :statistic="data.blockedConversation"
            :title="$t('dashboard.yourBlocking')"
            :description="$t('dashboard.yourBlockingDescription')"
            color="danger"
          />
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import { BRow, BCol, BOverlay } from "bootstrap-vue";
import Repository from "@/repositories/RepositoryFactory";
import ComingConversationLineChart from "./dashbaord/ComingConversationLineChart.vue";
import StatisticCardHorizontal from "./dashbaord/StatisticCardHorizontal.vue";
import RatingPieChart from "./dashbaord/RatingPieChart.vue";
import CallRatingPieChart from "./dashbaord/CallRatingPieChart.vue";

const DashboardRepository = Repository.get("dashboard");

export default {
  components: {
    BRow,
    BCol,
    BOverlay,
    ComingConversationLineChart,
    StatisticCardHorizontal,
    RatingPieChart,
    CallRatingPieChart,
  },
  data() {
    return {
      loading: false,
      data: {
        blockedConversation: 0,
        openConversation: 0,
        resolvedConversation: 0,
        ratingData: [],
        callRatingData: [],
      },
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    currentLocale(value, oldValue) {
      if (oldValue && value && this.data.ratingData.length) {
        this.$refs.ratingPieChart.mapRatingData(this.data.ratingData);
        this.$refs.callRatingPieChart.mapRatingData(this.data.callRatingData);
      }
    },
  },
  mounted() {
    this.index();
  },
  methods: {
    index() {
      this.loading = true;
      DashboardRepository.index()
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.data.blockedConversation = data.blockedConversation;
            this.data.openConversation = data.openConversation;
            this.data.resolvedConversation = data.resolvedConversation;
            this.data.ratingData = [...data.ratingChart];
            this.data.callRatingData = [...data.callRatingChart];
            this.$refs.ratingPieChart.mapRatingData(data.ratingChart);
            this.$refs.callRatingPieChart.mapRatingData(data.callRatingChart);
          }
        })
        .catch((error) => {
          this.loading = false;
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
